// src/services/authWatcher.js
import router from '@/router'

let intervalId = null

// const TEST_MODE = false
const TIMEOUT_SECONDS = 9000
const CHECK_INTERVAL_MS = 5000

export function startAuthWatcher() {
    stopAuthWatcher()
    console.log('[AuthWatcher] ▶ Started (timeout:', TIMEOUT_SECONDS, 's)')

    intervalId = setInterval(() => {
        console.log('[AuthWatcher] Checking token...')
        const token = localStorage.getItem('token')
        let tokenTimestamp = localStorage.getItem('token_timestamp')

        if (!token || !tokenTimestamp) {
            console.log('[AuthWatcher] No token or timestamp found')
            return
        }

        // تبدیل به عدد
        tokenTimestamp = Number(tokenTimestamp)

        // اگر برحسب ثانیه ذخیره شده بود
        if (tokenTimestamp < 1e12) {
            tokenTimestamp *= 1000
        }

        const now = Date.now()
        const diffMs = now - tokenTimestamp
        const diffSec = Math.floor(diffMs / 1000)

        console.log(`[AuthWatcher] Token age: ${diffSec}s  timeout: ${TIMEOUT_SECONDS}`)

        if (diffSec > TIMEOUT_SECONDS) {
            console.warn('[AuthWatcher] Token expired -> logging out user')
            localStorage.removeItem('token')
            localStorage.removeItem('token_timestamp')
            stopAuthWatcher()
            router.push('/login')
        }
    }, CHECK_INTERVAL_MS)
}

export function stopAuthWatcher() {
    if (intervalId) {
        clearInterval(intervalId)
        intervalId = null
        console.log('[AuthWatcher] ⏸ Stopped')
    }
}
